import * as React from 'react';

const LocationIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#E8F2FF" />
    <mask
      id="mask0_15763_102756"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15763_102756)">
      <path
        d="M20 30C18.2333 30 16.7917 29.7208 15.675 29.1625C14.5583 28.6042 14 27.8833 14 27C14 26.6 14.1208 26.2292 14.3625 25.8875C14.6042 25.5458 14.9417 25.25 15.375 25L16.95 26.475C16.8 26.5417 16.6375 26.6167 16.4625 26.7C16.2875 26.7833 16.15 26.8833 16.05 27C16.2667 27.2667 16.7667 27.5 17.55 27.7C18.3333 27.9 19.15 28 20 28C20.85 28 21.6708 27.9 22.4625 27.7C23.2542 27.5 23.7583 27.2667 23.975 27C23.8583 26.8667 23.7083 26.7583 23.525 26.675C23.3417 26.5917 23.1667 26.5167 23 26.45L24.55 24.95C25.0167 25.2167 25.375 25.5208 25.625 25.8625C25.875 26.2042 26 26.5833 26 27C26 27.8833 25.4417 28.6042 24.325 29.1625C23.2083 29.7208 21.7667 30 20 30ZM20 27C17.65 25.2667 15.8958 23.5833 14.7375 21.95C13.5792 20.3167 13 18.7167 13 17.15C13 15.9667 13.2125 14.9292 13.6375 14.0375C14.0625 13.1458 14.6083 12.4 15.275 11.8C15.9417 11.2 16.6917 10.75 17.525 10.45C18.3583 10.15 19.1833 10 20 10C20.8167 10 21.6417 10.15 22.475 10.45C23.3083 10.75 24.0583 11.2 24.725 11.8C25.3917 12.4 25.9375 13.1458 26.3625 14.0375C26.7875 14.9292 27 15.9667 27 17.15C27 18.7167 26.4208 20.3167 25.2625 21.95C24.1042 23.5833 22.35 25.2667 20 27ZM20 19C20.55 19 21.0208 18.8042 21.4125 18.4125C21.8042 18.0208 22 17.55 22 17C22 16.45 21.8042 15.9792 21.4125 15.5875C21.0208 15.1958 20.55 15 20 15C19.45 15 18.9792 15.1958 18.5875 15.5875C18.1958 15.9792 18 16.45 18 17C18 17.55 18.1958 18.0208 18.5875 18.4125C18.9792 18.8042 19.45 19 20 19Z"
        fill="#003594"
      />
    </g>
  </svg>
);

export default LocationIcon;
